import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { loadTrustpilotScript as loadScript } from "@/components/TrustpilotCollector";

// Official TrustBox, built from attributes the admin pasted at /admin/site. Hidden until set.
export default function TrustpilotWidget() {
  const [attrs, setAttrs] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    api.get("/site/trustpilot-widget").then((r) => setAttrs(r.data.widget?.attrs || null)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!attrs || !ref.current) return;
    loadScript().then(() => window.Trustpilot?.loadFromElement(ref.current, true));
  }, [attrs]);

  if (!attrs) return null;
  return (
    <section className="mt-16 max-w-4xl" data-testid="trustpilot-widget">
      <div ref={ref} className="trustpilot-widget" {...attrs}>
        <a href="https://www.trustpilot.com/review/shadowspeakjournal.com" target="_blank" rel="noopener noreferrer">
          Trustpilot
        </a>
      </div>
    </section>
  );
}
